import { MENU_ORDER_STATUS } from '../../helpers/enums';

export const formatDate = (timestamp) => {
  return new Date(timestamp).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatPrice = (price, currency = '$') => {
  // payablePrice appears to be already in dollars (like in PDF template)
  const priceValue = typeof price === 'string' ? parseFloat(price) : price;

  return `${currency}${priceValue.toFixed(2)}`;
};

export const getOrderStatusColor = (orderStatus) => {
  // Using MENU_ORDER_STATUS enum values
  switch (orderStatus) {
    case MENU_ORDER_STATUS.delivered:
      return 'text-green-600';
    case MENU_ORDER_STATUS.placed:
    case MENU_ORDER_STATUS.unconfirmed:
    case MENU_ORDER_STATUS.in_kitchen:
      return 'text-orange-600';
    case MENU_ORDER_STATUS.on_the_way:
    case MENU_ORDER_STATUS.arriving:
    case MENU_ORDER_STATUS.arrived:
    case MENU_ORDER_STATUS.out_for_delivery:
      return 'text-blue-600';
    case MENU_ORDER_STATUS.cancelled:
      return 'text-red-600';
    case MENU_ORDER_STATUS.unknown:
    default:
      return 'text-gray-600';
  }
};

export const getOrderStatusText = (orderStatus) => {
  switch (orderStatus) {
    case MENU_ORDER_STATUS.unknown:
      return 'Unknown';
    case MENU_ORDER_STATUS.unconfirmed:
      return 'Unconfirmed';
    case MENU_ORDER_STATUS.placed:
      return 'Placed';
    case MENU_ORDER_STATUS.in_kitchen:
      return 'In Kitchen';
    case MENU_ORDER_STATUS.on_the_way:
      return 'On the Way';
    case MENU_ORDER_STATUS.delivered:
      return 'Delivered';
    case MENU_ORDER_STATUS.cancelled:
      return 'Cancelled';
    case MENU_ORDER_STATUS.arriving:
      return 'Arriving';
    case MENU_ORDER_STATUS.arrived:
      return 'Arrived';
    case MENU_ORDER_STATUS.out_for_delivery:
      return 'Out for Delivery';
    default:
      return 'Unknown';
  }
};

export const getOrderTypeText = (orderType) => {
  switch (orderType) {
    case '1':
      return 'Pickup';
    case '2':
      return 'Delivery';
    case '3':
      return 'Dine In';
    default:
      return 'Unknown';
  }
};

export const getOrderTypeStyle = (orderType) => {
  switch (orderType) {
    case '1': // Pickup / Walk-in
      return 'bg-green-50 text-green-700';
    case '2': // Delivery
      return 'bg-blue-50 text-blue-700';
    case '3': // Dine In
      return 'bg-red-50 text-red-700';
    default:
      return 'bg-gray-50 text-gray-700';
  }
};

export const getPaymentMethodText = (paymentType) => {
  return paymentType === '0' ? 'Cash' : 'Card';
};

export const getCardUrl = (cardType) => {
  if (cardType === '6')
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/visasvg.svg`;
  else if (cardType === '5')
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/mastercardsvg.svg`;
  else if (cardType === '2')
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/amexsvg.svg`;
  else
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/credit-card-2.svg`;
};
